/* eslint-disable */
import React, { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { acceptOrder } from '@/models/orders/actions'
import StatusBadge from '@/components/StatusBadge';
import TenantLogo from '@/components/TenantLogo';
import PageableTable from '@/components/PageableTable';
import dayjs from 'dayjs';
import qs from 'qs';
import {
  Avatar,
  Tag,
  Breadcrumb,
  Tooltip,
  Row,
  Col,
  Statistic,
  message,
  Button,
  Icon,
  Modal,
  Input,
  Badge,
  Popover,
  Tabs
} from 'antd';
import * as utils from '@/utils';
import * as apis from '@/apis';
import * as actions from '@/models/orders/actions';
import * as services from '@/models/orders/services';
import Filter from './filter';
import styles from './orders.module.scss';
import { getCurrentUser } from '@/models/user/selectors';
import { retry } from 'redux-saga/effects';
import TagFlag from '@/components/TagFlag';
import { orderStatus } from '@/models/orders/defines/constants';
import * as taskHallServices from '@/models/taskHall/services';
import TenantStatusBadge from '../workspace/components/TenantStatusBadge';
import RetailCode from '@/components/RetailCode'
import VeteranStatus from '@/components/VeteranStatus';
import {
  getQuotationSummary,
  hasQuotationSummary,
  shouldShowQuotationSummary,
  shouldShowQuotationSummaryForOrder,
} from './quotationSummary';

const tenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';
const APP_MODE = process.env.APP_MODE === 'tenant' ? "staff" : "manager"
function useQuery(str) {
  return useMemo(() => qs.parse(str), [str]);
}

function getColumns(reloadList, history, handleRowClick, openNotes) {
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUser);
  const showQuotationSummary = shouldShowQuotationSummary(user);
  const quotationSummaryTextStyle = { whiteSpace: 'nowrap', color: '#fc0d1b' };
  const showAssignDialogHandler = useCallback((order) => (event) => {
    event.stopPropagation();
    dispatch(
      actions.showAssignDialog({
        title: '指派',
        id: order._id,
        onSuccess: reloadList,
      })
    );
  });
  const showAppealDialogHandler = useCallback((appeal, order_id, order) => (event) => {
    event.stopPropagation();
    dispatch(
      actions.showAppealDialog({
        title: '订单申诉',
        order,
        appeal: appeal,
        order_id: order_id,
        onSuccess: reloadList,
        type: 0, //申请类型 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
        user: user
      })
    );
  });
  const calcWokerFee = useCallback((order) => {
    // let total = order.worker_fee?.reduce((t, d) => (t += d.price), 0);
    let total = order?.worker_fee_total;
    if (order.bonus) {
      total += order?.bonus?.coupons || 0;
    }
    order?.worker_services?.forEach(item => {
      total += item.worker_fee_total || 0
      // total += item?.worker_fee?.reduce((t, d) => (t += d.price), 0);
      if (item.bonus) {
        total += item?.bonus?.coupons || 0;
      }
    });
    return total ? total.toFixed(2) : total;
  });
  const receiveOrder = useCallback((order) => (event) => {
    event.stopPropagation();
    dispatch(acceptOrder(order._id, localStorage.getItem(`current_conv_item_${process.env.APP_MODE}`), reloadList))
  });
  const calcOrderFee = useCallback((order, appeal_type) => {
    let total = 0;
    if (order.worker_deduction?.appeal_state == 2 && order.worker_deduction?.appeal_type == appeal_type) {
      total += order.worker_deduction.appeal_amount;
    }
    order?.worker_services?.forEach(item => {
      if (item.worker_deduction?.appeal_state == 2 && item.worker_deduction?.appeal_type == appeal_type) {
        total += item.worker_deduction.appeal_amount;
      }
    });
    return total ? total.toFixed(2) : total;
  });
  const isWokerFeeChange = useCallback((order, appeal_type) => {
    let rst = false;
    if (order.worker_deduction?.appeal_state == 2 && order.worker_deduction?.appeal_type == appeal_type) {
      rst = true;
    }
    order?.worker_services?.forEach(item => {
      if (item.worker_deduction?.appeal_state == 2 && item.worker_deduction?.appeal_type == appeal_type) {
        rst = true;
      }
    });
    return rst
  });
  const getScheduletext = (code) => {
    return {
      text: '111',
      style: { color: '#333' }
    }
  }
  return [
    // {
    //   key: '_id',
    //   title: '序号',
    //   width: 60,
    //   align: 'center',
    //   render: (text, record, idx) => (
    //     <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    //   ),
    // },
    {
      title: '工单号',
      key: '_id',
      width: 140,
      render: (item) => {
        const showOrderCreator = (event) => {
          event.stopPropagation();
          dispatch(
            actions.showCreateOrderDialog({
              title: '创建工单(再次上门)',
              prev_order: item,
            })
          );
        };
        return (
          <div onClick={e => e.stopPropagation()}>
            <div>{item.order_no}</div>
            <div>
              <Tag color="blue" style={{
                color: '#17A55C',
                background: 'transparent',
                borderColor: '#17A55C',
                cursor: 'pointer'
              }}
                onClick={
                  () => {
                    // handleRowClick(item)
                    history.push(`/workspace`, {
                      searchOrderNo: item.order_no
                    });
                  }
                }
              >操作</Tag>
              {item.status_code == 6003 && <Tag color="blue" style={{
                color: '#17A55C',
                background: 'transparent',
                borderColor: '#17A55C',
                cursor: 'pointer'
              }}
                onClick={showOrderCreator}
              >
                一键重发
              </Tag>}
            </div>
            {/* {item.prev_order && (
              <Tooltip title={item.prev_order.order_no}>
                <Tag className={styles.convTag} color="orange">
                  再次上门
                </Tag>
              </Tooltip>
            )} */}
          </div>
        )
      },
    },
    {
      title: '状态',
      width: 90,
      render: (item) => {
        const status = utils.getStatus(item);

        return (
          <>
            <StatusBadge style={{ ...status.style, margin: 0 }} className={styles.state}>
              {status.text}
            </StatusBadge>
            <TenantStatusBadge order={item} />
          </>
        );
      },
    },
    {
      title: '企业',
      width: 160,
      display: process.env.APP_MODE === 'manager',
      render: (item) => (
        <div>
          <span>{item?.tenant?.short_name}</span>
          <br />
          <span>{item?.tenant?.memo}</span>
        </div>
      ),
    },
    {
      title: '下单人',
      width: 140,
      render: (item) =>
        item.createdBy ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar shape="circle" src={item.createdBy.avatar} />
            <span style={{ paddingLeft: 5 }}>{item.createdBy.name}</span>
            {item.tenantAssignTo &&
              item.createdBy._id !== item.tenantAssignTo._id && (
                <Tooltip
                  title={`当前订单目前由 "${item.tenantAssignTo?.name}" 处理`}
                >
                  <i
                    className="iconfont"
                    style={{
                      fontSize: 14,
                      color: '#fc0d1b',
                      marginLeft: 5,
                      cursor: 'pointer',
                    }}
                  >
                    &#xe694;
                  </i>
                </Tooltip>
              )}
          </div>
        ) : (
          '-'
        ),
    },
    {
      title: '类型',
      width: 60,
      render: (item) => (
        <>
          {Array.isArray(item?.product_list) && <div>
            <Tag color={item?.product_list[0]?.service_type === 1 ? '#D7EAFF' : '#FFF0BE'}
              style={{ color: item?.product_list[0]?.service_type === 1 ? '#0787FF' : '#D68F00' }}>
              {item?.product_list[0]?.service_type === 1 ? '安装' : '维修'}
            </Tag>
          </div>}
          <div style={{ marginTop: 3 }}>
            <Tag color={item.payer_type === 1 ? '#D1EBCE' : '#FFE6D5'}
              style={{ color: item.payer_type === 1 ? '#009C4B' : '#FF731B' }}>
              {item.payer_type === 1 ? '保内' : '保外'}
            </Tag>
          </div>
        </>
      ),
    },
    {
      title: '创建时间',
      width: 100,
      render: (item) => dayjs(item.createdAt).format('YYYY-MM-DD  HH:mm:ss'),
    },
    // {
    //   title: '标签',
    //   width: 160,
    //   render: (item) => item.accept_status
    //   /*
    //   render: (order) => {
    //     return order.tags.map((tag) => {
    //       const { text, ...style } = utils.getTag(tag);
    //       return (
    //         <div>
    //           <StatusBadge key={tag} style={style} className={styles.state}>
    //             {text}
    //           </StatusBadge>
    //         </div>
    //       );
    //     });
    //   },*/
    // },
    {
      title: '客户信息',
      width: 200,
      render: (item) => (
        <div onClick={e => e.stopPropagation()}>
          <Tooltip title={item.contact_name + ' ' + item.contact_mobile}>
            <div style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}>{item.contact_name} <Icon type="phone" theme="filled" style={{ color: '#17A55C', fontSize: '12px' }} />{item.contact_mobile}</div>
          </Tooltip>
          <Tooltip title={item.address}>
            <div style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}>{item.address}</div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: '最新进度',
      width: 160,
      render: (item) => (
        <div onClick={e => e.stopPropagation()}>
          <div>
            <span style={{ marginRight: 5 }}>{utils.getEventByCode(parseInt(item.event_code))}</span>
            {
              // [orderStatus.GUAQI, orderStatus.WORKER_GUAQI].includes(parseInt(item.event_code)) && (
              // <Tooltip title="">
              //   <Icon type="question-circle" style={{ fontSize: '12px' }} />
              // </Tooltip>
              // )
            }
            {item.event_code == 6003 && (
              <Tooltip title={item.cancel_reason || '--'}>
                <Icon type="question-circle" style={{ fontSize: '12px' }} />
              </Tooltip>
            )}
            {item.event_code == 8000 && (
              <Tooltip title={item.guaqi_reason || '--'}>
                <Icon type="question-circle" style={{ fontSize: '12px' }} />
              </Tooltip>
            )}
            {item.event_code == 8008 && (
              <Tooltip title={item.cuidan_reason || '--'}>
                <Icon type="question-circle" style={{ fontSize: '12px' }} />
              </Tooltip>
            )}
            {(item.event_code == 80012 || item.event_code == 80013) && (
              <Tooltip title={item.event_reason || '--'}>
                <Icon type="question-circle" style={{ fontSize: '12px' }} />
              </Tooltip>
            )}
          </div>


          {/* {item.event_code == 8000 && <div>{item.guaqi_reason}</div>}
          {item.event_code == 8008 && <div>{item.cuidan_reason}</div>} */}
          {/* <div>{item.event_reason}</div> */}
          <div>{item.event_time ? dayjs(item.event_time).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
        </div>
      ),
    },
    {
      title: '价格',
      width: 150,
      render: (item) =>
        tenantMode ? (<>
          <div style={{ whiteSpace: 'nowrap', color: '#FF731B', fontWeight: 'bold' }}>
            ￥{item?.fee_total?.toFixed(2)}
          </div>
          {
            item.coupon && (
              <div style={{ whiteSpace: 'nowrap' }}>
                代金券抵扣：{item.coupon.coupons}
                <small> 元</small>
              </div>
            )
          }
          {(() => {
            let upNum = 0;
            let downNum = 0;
            item?.appeal_history?.forEach(val => {
              if (val?.appeal_state == 2) {
                if (val?.appeal_type == 1) {
                  downNum += val?.appeal_amount || 0
                } else {
                  upNum += val?.appeal_amount || 0
                }
              }
            })
            return <>
              {upNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                商家申诉上调：{utils.priceToFixed(upNum, 2)}<small> 元</small>
              </div>}
              {downNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                商家申诉下调：{utils.priceToFixed(downNum, 2)}<small> 元</small>
              </div>}
            </>
          })()}

          {(() => {
            let upNum = 0;
            let downNum = 0;
            item?.tenant_deduction_history?.forEach(val => {
              if (val?.appeal_state == 2) {
                if (val?.appeal_type == 1) {
                  downNum += val?.appeal_amount || 0
                } else {
                  upNum += val?.appeal_amount || 0
                }
              }
            })
            return <>
              {upNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                客服上调商家：{utils.priceToFixed(upNum, 2)}<small> 元</small>
              </div>}
              {downNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                客服下调商家：{utils.priceToFixed(downNum, 2)}<small> 元</small>
              </div>}
            </>
          })()}
          {/* {item.appeal?.appeal_state == 2 && (<div style={{ whiteSpace: 'nowrap' }}>
            商家申诉{item?.appeal?.appeal_type == 1 ? '下调' : '上调'}：{item?.appeal?.appeal_amount}
            <small> 元</small>
          </div>)}
          {item.tenant_deduction?.appeal_state == 2 && (<div style={{ whiteSpace: 'nowrap' }}>
            客服{item?.tenant_deduction?.appeal_type == 1 ? '下调' : '上调'}商家：{item?.tenant_deduction?.appeal_amount}
            <small> 元</small>
          </div>)} */}
        </>
        ) : (
          <>
            <div style={{ whiteSpace: 'nowrap' }}>
              商家：{item?.fee_total?.toFixed(2)}
              <small> 元</small>
            </div>

            {
              item.coupon && (
                <div style={{ whiteSpace: 'nowrap' }}>
                  代金券抵扣：{item?.coupon?.coupons}
                  <small> 元</small>
                </div>
              )
            }

            {(() => {
              let upNum = 0;
              let downNum = 0;
              item?.appeal_history?.forEach(val => {
                if (val?.appeal_state == 2) {
                  if (val?.appeal_type == 1) {
                    downNum += val?.appeal_amount || 0
                  } else {
                    upNum += val?.appeal_amount || 0
                  }
                }
              })
              return <>
                {upNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                  商家申诉上调：{utils.priceToFixed(upNum, 2)}<small> 元</small>
                </div>}
                {downNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                  商家申诉下调：{utils.priceToFixed(downNum, 2)}<small> 元</small>
                </div>}
              </>
            })()}

            {(() => {
              let upNum = 0;
              let downNum = 0;
              item?.tenant_deduction_history?.forEach(val => {
                if (val?.appeal_state == 2) {
                  if (val?.appeal_type == 1) {
                    downNum += val?.appeal_amount || 0
                  } else {
                    upNum += val?.appeal_amount || 0
                  }
                }
              })
              return <>
                {upNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                  客服上调商家：{utils.priceToFixed(upNum, 2)}<small> 元</small>
                </div>}
                {downNum > 0 && <div style={{ whiteSpace: 'nowrap' }}>
                  客服下调商家：{utils.priceToFixed(downNum, 2)}<small> 元</small>
                </div>}
              </>
            })()}

            {/* {item.appeal?.appeal_state == 2 && (<div style={{ whiteSpace: 'nowrap' }}>
              商家申诉{item.appeal.appeal_type == 1 ? '下调' : '上调'}：{item?.appeal?.appeal_amount}
              <small> 元</small>
            </div>)}

            {item.tenant_deduction?.appeal_state == 2 && (<div style={{ whiteSpace: 'nowrap' }}>
              客服{item?.tenant_deduction?.appeal_type == 1 ? '下调' : '上调'}商家：{item?.tenant_deduction?.appeal_amount}
              <small> 元</small>
            </div>)} */}

            <div style={{ whiteSpace: 'nowrap' }}>
              师傅：
              {calcWokerFee(item)}
              <small> 元</small>
            </div>

            {isWokerFeeChange(item, 1) && (<div style={{ whiteSpace: 'nowrap' }}>
              客服下调师傅：{calcOrderFee(item, 1)}
              <small> 元</small>
            </div>)}

            {isWokerFeeChange(item, 2) && (<div style={{ whiteSpace: 'nowrap' }}>
              客服上调师傅：{calcOrderFee(item, 2)}
              <small> 元</small>
            </div>)}
          </>
        ),
    },
    {
      title: '报价信息',
      width: 120,
      display: showQuotationSummary,
      render: (item) => {
        if (!shouldShowQuotationSummaryForOrder(item, user)) {
          return null;
        }

        const summary = getQuotationSummary(item);

        return (
          <div onClick={e => e.stopPropagation()}>
            <div style={quotationSummaryTextStyle}>最低报价：{summary.quotationMinPriceText}</div>
            <div style={quotationSummaryTextStyle}>报价师傅：{summary.quotationNumText}</div>
          </div>
        );
      },
    },
    {
      title: '当前指派师傅',
      width: 200,
      display: process.env.APP_MODE === 'manager',
      render: (item) => {
        if (item.worker) {
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Avatar shape="circle" src={item.worker?.user?.avatar} />
              <div style={{ flex: 1, overflow: 'hidden', paddingLeft: 5 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: '10px' }}>{item.worker?.realname}</div>
                  <div>
                    <VeteranStatus isVeteran={item.worker?.isVeteran} />
                    {item.worker?.isMargin == 1 ?
                      <img src="/images/icon-defend-active.png" style={{ width: 22, height: 22, marginRight: 10 }} /> :
                      <img src="/images/icon-defend.png" style={{ width: 22, height: 22, marginRight: 10 }} />
                    }
                  </div>
                </div>
                <div><Icon type="phone" theme="filled" style={{ color: '#17A55C', fontSize: '12px' }} /> {item.worker?.user?.mobile || '--'}</div>
              </div>
            </div>
          );
        }

        if (!hasQuotationSummary(item)) {
          return '未指定';
        }

        const summary = getQuotationSummary(item);

        return (
          <div onClick={e => e.stopPropagation()}>
            <div style={quotationSummaryTextStyle}>最低报价：{summary.quotationMinPriceText}</div>
            <div style={quotationSummaryTextStyle}>报价师傅：{summary.quotationNumText}</div>
          </div>
        );
      },
    },
    {
      title: '当前受理客服',
      width: 160,
      render: (item) =>
        item.assignTo ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar shape="circle" src={item.assignTo.avatar} />
            <span style={{ paddingLeft: 5 }}>{item.assignTo.name}</span>
          </div>
        ) : (
          '未指派'
        ),
    },

    // {
    //   title: '验证码交单',
    //   width: 120,
    //   render: (item) => item.is_captcha ? '是' : '否',
    // },
    // {
    //   title: '是否返件',
    //   width: 100,
    //   render: (item) => item.is_return ? '是' : '否',
    // },
    // {
    //   title: '是否亏损',
    //   width: 100,
    //   display: process.env.APP_MODE === 'manager',
    //   render: (item) => item.is_loss ? '是' : '否',
    // },
    {
      title: '备注',
      width: 60,
      render: (item) => (
        <div onClick={e => e.stopPropagation()}>
          <div>
            <TagFlag itemId={item.task_id} flag={item.tag_flag} change={() => {
              reloadList()
            }} />
          </div>
          <div>
            <Popover
              trigger="hover"
              placement="rightTop"
              content={(
                <div style={{ width: 400, maxHeight: 400, overflowX: 'hidden' }}>
                  <div>
                    <div className={styles.sectionTitle}>
                      <span className={styles.title}>{process.env.APP_MODE === 'manager' ? '客服' : ''}备注历史</span>
                      <div className={styles.line}></div>
                    </div>

                    <div className={styles.commenthistory}>
                      {
                        (process.env.APP_MODE === 'manager' ? item.customMemo : item.tenantMemo).map((val, index) => (
                          <div className={styles.historyitem} key={index}>
                            <div className={styles.itemhead}>
                              <div className={styles.time}>
                                {dayjs(val.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                                <span className={styles.name}>{val?.user?.name}</span>
                              </div>
                              <div className={styles.other} >

                              </div>
                            </div>
                            <div className={styles.text}>{val.memo}</div>
                          </div>)
                        )
                      }

                      {(process.env.APP_MODE === 'manager' ? item.customMemo : item.tenantMemo)?.length == 0 && <div style={{ padding: 10, textAlign: 'center' }}>暂无备注</div>}
                    </div>
                  </div>
                  {process.env.APP_MODE === 'manager' && <>
                    <div>
                      <div className={styles.sectionTitle}>
                        <span className={styles.title}>商家备注历史</span>
                        <div className={styles.line}></div>
                      </div>

                      <div className={styles.commenthistory}>
                        {
                          item.tenantMemo?.map((val, index) => (
                            <div className={styles.historyitem} key={index}>
                              <div className={styles.itemhead}>
                                <div className={styles.time}>
                                  {dayjs(val.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                                  <span className={styles.name}>{val?.user?.name}</span>
                                </div>
                                <div className={styles.other} >

                                </div>
                              </div>
                              <div className={styles.text}>{val.memo}</div>
                            </div>)
                          )
                        }

                        {item?.tenantMemo?.length == 0 && <div style={{ padding: 10, textAlign: 'center' }}>暂无备注</div>}
                      </div>
                    </div>
                    <div>
                      <div className={styles.sectionTitle}>
                        <span className={styles.title}>师傅备注历史</span>
                        <div className={styles.line}></div>
                      </div>

                      <div className={styles.commenthistory}>
                        {
                          (item?.workerMemo || [])?.map((val, index) => (
                            <div className={styles.historyitem} key={index}>
                              <div className={styles.itemhead}>
                                <div className={styles.time}>
                                  {dayjs(val.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                                  <span className={styles.name}>{val?.user?.name}</span>
                                </div>
                                <div className={styles.other} >

                                </div>
                              </div>
                              <div className={styles.text}>{val.memo}</div>
                            </div>)
                          )
                        }
                        {item?.workerMemo?.length == 0 && <div style={{ padding: 10, textAlign: 'center' }}>暂无备注</div>}
                      </div>
                    </div>
                  </>}
                </div>
              )} >
              <img src={`/images/icon-notes.png`} style={{ width: '18px', height: '18px', cursor: 'pointer' }} onClick={() => {
                openNotes(item)
              }} />
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: '操作',
      fixed: 'right',
      width: 160,
      display: false,
      render: (item) => {
        const showOrderCreator = (event) => {
          event.stopPropagation();
          dispatch(
            actions.showCreateOrderDialog({
              title: '创建工单(再次上门)',
              prev_order: item,
            })
          );
        };
        const nav2Conv = (event) => {
          event.stopPropagation();
          history.push(`/workspace`, { order: item._id });
        };

        return (
          <div>
            {/* <a onClick={showOrderDetail}>查看详情</a>
            <Divider type="vertical" /> */}
            {item.active_state === 1 && (
              (process.env.APP_MODE === 'manager' && item.receive_state != 1) ? (
                <span className={styles.controlBtn}>
                  <a onClick={receiveOrder(item)}>接收</a>
                </span>
              ) :
                (
                  <span className={styles.controlBtn}>
                    <a onClick={showAssignDialogHandler(item)}>指派</a>
                  </span>
                )
            )}
            {item.active_state === 0 && (
              <span className={styles.controlBtn}>
                <a onClick={/*showOrderCreator*/handleRowClick(item)}>详情</a>
              </span>
            )}
            {item.status_code === 6002 && (
              (process.env.APP_MODE === 'manager' && item.appeal) || process.env.APP_MODE === 'tenant'
            ) && (
                <span className={styles.controlBtn}>
                  <a onClick={showAppealDialogHandler(item.appeal, item._id, item)}>申诉</a>
                </span>
              )}
            {((process.env.APP_MODE === 'manager' &&
              item?.assignTo?._id == window.uid) ||
              (process.env.APP_MODE === 'tenant' &&
                [item.tenantAssignTo?._id, item.tenantAssignTo].includes(
                  window.uid
                ))) &&
              item.active_state === 1 && (
                <span className={styles.controlBtn}>
                  <a onClick={nav2Conv}>跳转</a>
                </span>
              )}
          </div>
        );
      },
    },
  ].filter((item) => item.display !== false);
}

// 全局只有session跟工作台适合用redux数据，其他均有ajax实时请求
function OrderList(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const query = useQuery(location.search.slice(1));
  const limit = query.limit || 30;
  const offset = query.offset || 0;
  const [visibleNotes, setVisibleNotes] = useState(false);
  const [currentNotes, setCurrentNotes] = useState(null);
  const [noteValue, setNoteValue] = useState('');
  const [flicker, setFlicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [orders, setOrders] = useState([]);
  const [taskCount, setTaskCount] = useState({});
  const [ticketType, setTicketType] = useState('0');

  const flickerTimer = useRef();
  const pagination = {
    showTotal: (total) => `共计 ${total}条 订单`,
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1,
  };
  const user = useSelector(getCurrentUser);
  const id = user.getIn([APP_MODE, "_id"])
  const showOrderCreator = useCallback((user, id) => {
    if (user.get('originTenant') === 0) {
      message.warning('请使用该子账号的员工账号创建订单')
      return false
    }
    dispatch(
      actions.showCreateOrderDialog({
        title: '创建工单',
        user,
        dispatch
      })
    );
  }, []);
  const fetchTaskCountData = (type = 0) => {
    // 任务大厅：0，超时工单：1，我的消息：2，企业工作台数据：4
    taskHallServices.fetchTaskCount({
      type: tenantMode ? 4 : 0,
    }).then(result => {
      setTaskCount(result || {})
    }).catch((err) => { })
  };

  const fetch = useCallback(() => {
    setLoading(true);
    const queryData = { ...query, limit }
    if (isManagerMode) {
      if (Number(ticketType)) {
        queryData.ticket_type = Number(ticketType)
      } else {
        delete queryData.ticket_type
      }
    }
    services
      .getOrderList(queryData)
      .then((result) => {
        setOrders(result.data);
        setTotal(result.total);
        dispatch(actions.ordersFetched(result)); // 倒是可以更新列表，不浪费资源 😁
      })
      .catch((err) => {
        message.error(err.message || '获取订单列表失败，请刷新重试');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [query, ticketType]);

  const navigateTo = useCallback(
    (param) => {
      window.scrollTop = 0;
      history.push(`/orders?${qs.stringify(param)}`);
    },
    [query]
  );
  const handleTableChange = useCallback(
    (param) => {
      navigateTo({ ...query, ...param });
    },
    [query]
  );
  const filterOnChange = useCallback((param) => {
    console.log('filterOnChange:', param);
    navigateTo({ ...param, offset: 0 });
  }, []);

  const handleRowClick = useCallback((item) => () => {
    dispatch(
      actions.orderPreview({
        title: `工单 - ${item.tenant.short_name} ${item.order_no}`,
        id: item._id,
      })
    );
  });
  const openNotes = (item) => {
    setNoteValue('')
    setCurrentNotes(item)
    setVisibleNotes(true)
  }
  const submitNote = () => {
    if (!noteValue) {
      return message.info('请输入备注信息')
    }
    // 客服备注历史：1，商家备注历史：2，师傅备注历史：3
    let type = 1
    if (isManagerMode) {
      type = 1
    } else if (tenantMode) {
      type = 2
    }
    const datas = {
      orderId: currentNotes._id,
      memo: noteValue,
      type: type
    }
    services.addMemo2(datas).then(result => {
      message.success('提交成功')
      setNoteValue('')
      setCurrentNotes(null)
      setVisibleNotes(false)
      fetch();
    }).catch(err => {
      message.error(err?.message || '发生错误')
    }).finally(() => {
    })
  }
  const columns = getColumns(() => fetch(), history, handleRowClick, openNotes);
  const [statistic, setStatistic] = useState({});

  const getStatisticData = (ticket_type) => {
    const queryData = {}
    if (isManagerMode) {
      if (Number(ticket_type)) {
        queryData.ticket_type = Number(ticket_type)
      }
    }
    apis
      .getOrderStatistic(queryData)
      .then((data) => {
        setStatistic(data);
      })
      .catch((err) => {
        message.error(err.message || '获取统计数据错误');
      });
  }
  useEffect(() => {
    fetch();
  }, [location.search]);

  useEffect(() => {
    getStatisticData()
    flickerTimer.current = setInterval(() => {
      setFlicker(v => !v)
    }, 600);
    fetchTaskCountData()
    return () => {
      clearInterval(flickerTimer.current)
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>工单列表</Breadcrumb.Item>
          <Breadcrumb.Item>所有工单</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <Badge count={flicker ? (taskCount.opTipNum + taskCount.tipNum) : 0}>
            <Button type="primary" icon="message" ghost style={{ marginLeft: '10px' }} onClick={() => {
              history.push(`/workspace`);
            }}>工作台</Button>
          </Badge>
          {tenantMode && <Button type="primary" style={{ marginLeft: '10px' }}
            onClick={showOrderCreator.bind(this, user, id)}>创建保内工单</Button>}

          {tenantMode && <RetailCode />}
        </div>
      </div>
      {isManagerMode && <Tabs
        animated={false}
        activeKey={ticketType}
        onChange={(key) => {
          setTicketType(key)

          let obj = {}
          if (key) {
            obj.ticket_type = key
          }
          filterOnChange(obj)
          getStatisticData(key)
        }}>
        <Tabs.TabPane tab="全部" key="0"></Tabs.TabPane>
        <Tabs.TabPane tab="平台指派师傅" key="1"></Tabs.TabPane>
        <Tabs.TabPane tab="商家指派师傅" key="2"></Tabs.TabPane>
        <Tabs.TabPane tab="保外工单" key="3"></Tabs.TabPane>
      </Tabs>}
      <div className={styles.card}>
        <Row>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="待指派"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.unAssignedWorkerOrdrCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="待预约"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.unServiceTimeOrdrCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="待上门"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.unDoorOrdrCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="正在进行中"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.processedOrderCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              // title="待平台验收"
              title="待客服确认"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.platfoemUncheckedOrderCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="工单总数"
              suffix="条"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={statistic?.totalOrderCount}
            />
          </Col>
          <Col md={3} sm={12} xs={24}>
            <Statistic
              title="取消率"
              suffix="%"
              valueStyle={{ color: '#ff6a39', fontWeight: 500 }}
              value={
                (
                  statistic?.canceledOrderCount / statistic?.totalOrderCount
                )?.toFixed(1) * 100 || 0
              }
            />
          </Col>
        </Row>
      </div>
      <div className={styles.content}>
        <Filter query={query} onChange={filterOnChange} key={ticketType}></Filter>
        <PageableTable
          className={styles.table}
          columns={columns}
          rowKey="_id"
          size="middle"
          dataSource={orders}
          pagination={pagination}
          total={total}
          limit={+limit}
          offset={+offset || 0}
          onChange={handleTableChange}
          loading={loading}
          // onRow={(record) => ({
          //   onClick: handleRowClick(record),
          // })}
          scroll={{ x: '100%' }}
        />
      </div>

      <Modal
        title="备注"
        visible={visibleNotes}
        onOk={() => { submitNote() }}
        onCancel={() => { setVisibleNotes(false) }}
      >
        <Input.TextArea rows={6} value={noteValue} placeholder="请输入备注信息"
          onChange={(e) => { setNoteValue(e.target.value) }} />
      </Modal>
    </div>
  );
}

export default utils.withQuery(OrderList);
